import { render, staticRenderFns } from "./table-th.vue?vue&type=template&id=22405fba&"
import script from "./table-th.vue?vue&type=script&lang=js&"
export * from "./table-th.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports